var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrgNeeds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.5V8.9H0V5.5C0 3.3 1.8 1.5 4 1.5C5.4 1.5 6.7 2.5 6.8 2.7C7.6 3.4 8 4.5 8 5.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3 58.3C56.3 60.5 54.5 62.3 52.2 62.3H18.4C19.4 61.2 19.9 59.8 19.9 58.3V54.9H56.3V58.3Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7 38.7H34.1V46.3H41.7V38.7Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 38.7C18.7 38.7 17 40.4 17 42.5C17 44.6 18.7 46.3 20.8 46.3C22.9 46.3 24.6 44.6 24.6 42.5C24.6 40.4 22.9 38.7 20.8 38.7Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 8C18.7 8 17 9.7 17 11.8C17 13.9 18.7 15.6 20.8 15.6C22.9 15.6 24.6 13.9 24.6 11.8C24.6 9.7 22.9 8 20.8 8Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7 23.4H34.1V31H41.7V23.4Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 23.4C18.7 23.4 17 25.1 17 27.2C17 29.3 18.7 31 20.8 31C22.9 31 24.6 29.3 24.6 27.2C24.6 25.1 22.9 23.4 20.8 23.4Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 1.5C41.1 1.5 58.3 1.5 8.5 1.5C10.9 6.3 9.7 -1.2 10 58.4C10 60.6 11.8 62.4 14 62.4C16.2 62.4 18 60.6 18 58.4V54C18 53.4 18.4 53 19 53H48.8V5.5C48.8 3.3 47 1.5 44.8 1.5ZM20.8 48.3C17.6 48.3 15 45.7 15 42.5C15 39.3 17.6 36.7 20.8 36.7C24 36.7 26.6 39.3 26.6 42.5C26.6 45.7 24 48.3 20.8 48.3ZM20.8 32.9C17.6 32.9 15 30.3 15 27.1C15 23.9 17.6 21.3 20.8 21.3C24 21.3 26.6 23.9 26.6 27.1C26.6 30.3 24 32.9 20.8 32.9ZM20.8 17.6C17.6 17.6 15 15 15 11.8C15 8.6 17.6 6 20.8 6C24 6 26.6 8.6 26.6 11.8C26.6 15 24 17.6 20.8 17.6ZM43.7 47.3C43.7 47.9 43.3 48.3 42.7 48.3H33.1C32.5 48.3 32.1 47.9 32.1 47.3V37.7C32.1 37.1 32.5 36.7 33.1 36.7H42.7C43.3 36.7 43.7 37.1 43.7 37.7V47.3ZM43.7 31.9C43.7 32.5 43.3 32.9 42.7 32.9H33.1C32.5 32.9 32.1 32.5 32.1 31.9V22.3C32.1 21.7 32.5 21.3 33.1 21.3H42.7C43.3 21.3 43.7 21.7 43.7 22.3V31.9ZM46.1 9.5L43.7 11V16.5C43.7 17.1 43.3 17.5 42.7 17.5H33.1C32.5 17.5 32.1 17.1 32.1 16.5V7C32.1 6.4 32.5 6 33.1 6H42.7C43.3 6 43.7 6.4 43.7 7V8.7L45 7.9C45.5 7.6 46.1 7.7 46.4 8.2C46.7 8.6 46.5 9.2 46.1 9.5Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1 15.6H41.7V12.4L37.9 14.8C37.4 15.1 36.8 15 36.5 14.5L35 11.9C34.7 11.4 34.9 10.8 35.4 10.5C35.9 10.2 36.5 10.4 36.8 10.9L37.8 12.6L41.8 10V8H34.2V15.6H34.1Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63 7.9H52.6V40.9H63V7.9Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53 42.9L56.9 50.1C57.3 50.8 58.3 50.8 58.7 50.1L62.6 42.9H53Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63 5.9V3.3C63 1.5 61.5 0 59.7 0H55.9C54.1 0 52.6 1.5 52.6 3.3V5.9H63Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgNeeds);
export default __webpack_public_path__ + "static/media/org-needs.42256f1c2536f92299a7ebaae36bba13.svg";
export { ForwardRef as ReactComponent };